import { render, staticRenderFns } from "./LocationAlternative.vue?vue&type=template&id=62f53c72"
import script from "./LocationAlternative.vue?vue&type=script&lang=js"
export * from "./LocationAlternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports